import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { rateSchema } from "../rate";

export const referralRewardRuleSchema = z.object({
  id: z.string(),
  code: z.string(),
  quotas: z.number(),
  operator: z.enum(["equal", "gt"]),
  rateId: z.string().nullable().optional(),
  rate: rateSchema.nullable().optional(),
  amount: z.number(),
  type: z.enum(["money", "souscription"]),
  is_active: z.boolean(),
});

export class ReferralRewardRuleDto extends createZodDto(referralRewardRuleSchema) {}
